import baseService from "../BaseService";
import mixinsMessage from "@/mixins/message";
import QhPlano from "@/model/qh/QhPlano";
import ResultadoPesquisa from "@/model/comum/ResultadoPesquisa";
export default {
  listarAnos(ativo) {
    return baseService
      .get("/api/qh-planos/anos", {
        params: { ativo: ativo != null ? ativo : null }
      })
      .then(response => {
        if (response && response.data) {
          return response.data;
        }
        return [];
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar listar anos de planos");
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  listarNumeros(ano) {
    return baseService
      .get("/api/qh-planos/numeros", {
        params: {
          ano: ano
        }
      })
      .then(response => {
        if (response && response.data) {
          return response.data;
        }
        return [];
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar listar números de planos");
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  listarTodos(plano, numeroPagina, qtdTotal) {
    return baseService
      .get("/api/qh-planos", {
        params: {
          id: plano ? plano.id : null,
          ano: plano ? plano.ano : null,
          numero: plano ? plano.numero : null,
          pagina: numeroPagina ? numeroPagina : null,
          total: qtdTotal ? qtdTotal : null
        }
      })
      .then(response => {
        if (response && response.data) {
          return new ResultadoPesquisa(response.data);
        }
        return null;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar listar Planos de Quadro Horário");
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  editar(id) {
    return baseService
      .get("/api/qh-planos/" + id)
      .then(response => {
        if (response && response.data) {
          return new QhPlano(response.data);
        }
        return null;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar editar Plano de Quadro Horário");
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  salvar(plano) {
    if (plano.id) {
      return baseService
        .put("/api/qh-planos/" + plano.id, plano)
        .then(response => {
          mixinsMessage.methods.success(response.data);
          return response.data;
        })
        .catch(function(error) {
          mixinsMessage.methods.error(
            "Erro ao tentar atualizar Plano de Quadro Horário",
            error
          );
          // eslint-disable-next-line no-console
          console.error(error);
        });
    } else {
      return baseService
        .post("/api/qh-planos", plano)
        .then(response => {
          mixinsMessage.methods.success(response.data);
          return response.data;
        })
        .catch(function(error) {
          mixinsMessage.methods.error(
            "Erro ao tentar cadastrar Plano de Quadro Horário",
            error
          );
          // eslint-disable-next-line no-console
          console.error(error);
        });
    }
  },
  alternarAtivo(plano) {
    return baseService
      .put("/api/qh-planos/" + plano.id + "/alternar-ativo")
      .then(response => {
        mixinsMessage.methods.success(response.data);
        return response.data;
      })
      .catch(function(error) {
        mixinsMessage.methods.error(
          "Erro ao tentar alternar status do Plano de Quadro Horário",
          error
        );
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  excluir(plano) {
    return baseService
      .delete("/api/qh-planos/" + plano.id)
      .then(response => {
        mixinsMessage.methods.success(response.data);
        return response.data;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar excluir Plano de Quadro Horário", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }
};
